import type { IGcfProductList } from 'src/interfaces';

export const showSettingUpdatedInfoBox = (productList?: IGcfProductList) => {
  const fieldsToCheck = [
    productList?.config?.badges?.groupBadge?.style,
    productList?.config?.badges?.imageBadge?.style,
    productList?.config?.badges?.itemBadge?.style,
  ];

  return fieldsToCheck.some((config) => !!config);
};
